import http from "@/shared/http";
const httpPlugin = {
  install(app: any) {
    app.config.globalProperties.$httpService = http;
  },
};

export default httpPlugin;
